// 003 (FR-019, FR-019a; R-4): a signed-in school-admin-only user opened a school link. Web: the
// FR-019 message with Use as a parent too, Go to school admin and Log out. Android: the R-4 message
// with Use as a parent too and Log out. No pending join is recorded here.
import { Link } from "expo-router";
import { StyleSheet, View } from "react-native";

import { useSessionController } from "@/session/hooks";
import { StateView } from "@/shell/StateView";
import { makeStyles } from "@/theme/makeStyles";
import type { Platform } from "@/session/types";
import { Button } from "@/ui/Button";
import { LinkButton } from "@/ui/LinkButton";
import { Text } from "@/ui/Text";

import { JOIN_COPY } from "./copy";
import { useEnableParentRole } from "./useEnableParentRole";

const useStyles = makeStyles((t) =>
  StyleSheet.create({ stack: { gap: t.space.lg } }),
);

export function ParentRoleOffer({
  platform,
  onParent,
}: {
  platform: Platform;
  /** Called once the session holds PARENT (and parent mode is on). */
  onParent: () => void;
}) {
  const styles = useStyles();
  const controller = useSessionController();
  const { state, run } = useEnableParentRole();
  const copy = JOIN_COPY.parentRole;

  async function turnOnParent() {
    if ((await run()) === "parent") onParent();
  }

  return (
    <View style={styles.stack} testID="join-parent-offer">
      <Text>{platform === "web" ? copy.webMessage : copy.androidMessage}</Text>
      {state.status === "error" ? (
        <StateView
          status="error"
          error={state.error}
          onRetry={() => void turnOnParent()}
        />
      ) : null}
      <Button
        onPress={() => void turnOnParent()}
        pending={state.status === "pending"}
        disabled={state.status === "pending"}
      >
        {copy.useAsParent}
      </Button>
      {platform === "web" ? (
        <Link href="/school" asChild>
          <Button variant="outline">{copy.goToSchoolAdmin}</Button>
        </Link>
      ) : null}
      <LinkButton onPress={() => void controller.signOut("USER")}>
        {copy.logOut}
      </LinkButton>
    </View>
  );
}
